
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_default",
      function () {
        return require("private-next-pages/_default.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_default"])
      });
    }
  